import React from 'react';
import { COLORS } from 'config/theme';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    borderRadius: 200,
    letterSpacing: 1.3,
    fontSize: 15,
    fontWeight: 700,
    '&:hover': {
      backgroundColor: 'rgba(51, 65, 142, 0.08)',
    },
    '& img, & svg': {
      marginRight: 8,
    },
  },
  contained: {
    '&:hover': {
      color: '#fff',
      backgroundColor: COLORS.primaryDarker,
    },
  },
};

const ButtonAppNew = ({
  classes,
  hide,
  children,
  ...rest
}) => {
  if (hide) return null;

  return (
    <Button
      color="primary"
      {...rest}
      className={classes.button}
      classes={{
        contained: classes.contained,
      }}
    >
      {children}
    </Button>
  );
};

export default withStyles(styles)(ButtonAppNew);



// WEBPACK FOOTER //
// ./src/components/ButtonAppNew/ButtonAppNew.js